import { useCallback, useMemo, useState } from 'react';
export const useBooleanToggle = (initalState = false) => {
  const [state, setState] = useState(initalState);
  const updateState = useCallback(newState => {
    if (typeof newState === 'boolean') {
      setState(newState);
    } else {
      setState(prevState => !prevState);
    }
  }, []);
  return useMemo(() => [state, updateState], [state, updateState]);
};